import { ReactNode } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden w-full max-w-full">
      <Navigation />
      <main className="flex-1 pt-20 overflow-x-hidden">{children}</main>
      <Footer />
    </div>
  );
}